module.exports = __webpack_public_path__ + "static/media/azTaxBG.e315cf35.png";